const ChurchCenterAttendeesEdit = {
  initialize(disableCostCheck) {
    this.watchRemoveButtons()
    this.watchAddButtons()
    this.updateTrashCans()
    if (!disableCostCheck) {
      this.snapshotForm()
    }
  },

  snapshotForm() {
    setTimeout(function() {
      const $form = $(".modal form")
      return $form.data("originalData", $form.serialize())
    }, 10)
    $(".modifies-cost-js").on("change", function() {
      const $form = $("form.edit_attendee")
      const action = $form.prop("action").split("?", 2)
      const url = action[0] + "/cost_check" + "?" + action[1]
      return $.ajax({
        method: "POST",
        headers: { "X-CSRF-Token": Rails.csrfToken() },
        url,
        data: $form.serialize(),
        dataType: "script"
      })
    })
    return $("a.block-list__link").on("click", function() {
      const $form = $(".modal form")
      if ($form.serialize() !== $form.data("originalData")) {
        const name = $(".form-section-container__heading")
          .text()
          .trim()
        return confirm(`You have unsaved changes to ${name}. Continue anyway?`)
      }
    })
  },

  updateTrashCans() {
    this.updateGenericTrashCans("phone-number")
    this.updateGenericTrashCans("email")
    return this.updateGenericTrashCans("address")
  },

  updateGenericTrashCans(thing) {
    if ($(`.${thing}-is-required-js`).length !== 1) {
      return
    }
    const visibleCount = $(`.person-${thing}-js:visible`).length
    if (visibleCount < 2) {
      return $(`.remove-${thing}-js`).addClass("hide")
    } else {
      return $(`.remove-${thing}-js`).removeClass("hide")
    }
  },

  watchRemoveButtons() {
    return $(".attendee-form-js").on("click", event => {
      if ($(event.target).hasClass("destroy-nested-association-button-js")) {
        event.preventDefault()
        return Sprinkles.DestroyNestedAssociationButton.hideAndToggle(event, () => {
          return this.updateTrashCans()
        })
      }
    })
  },

  watchAddButtons() {
    return $(".build-nested-association-button-js").on("click", event => {
      return Sprinkles.BuildNestedAssociationButton.build(event, () => {
        Sprinkles.CustomSelect.set()
        return this.updateTrashCans()
      })
    })
  }
}

export default ChurchCenterAttendeesEdit
